// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TelegramQueryVariables = Types.Exact<{
  site: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type TelegramQuery = { __typename?: 'Query', features?: { __typename?: 'Features', id: string, isTelegramLoginActive?: boolean } };


export const TelegramQueryDocument = /*#__PURE__*/ gql`
    query TelegramQuery($site: String!, $name: String!) {
  features {
    id
    isTelegramLoginActive: isFlagActive(site: $site, name: $name)
  }
}
    `;
export function useTelegramQuery(baseOptions: Apollo.QueryHookOptions<TelegramQuery, TelegramQueryVariables> & ({ variables: TelegramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelegramQuery, TelegramQueryVariables>(TelegramQueryDocument, options);
      }
export function useTelegramQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelegramQuery, TelegramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelegramQuery, TelegramQueryVariables>(TelegramQueryDocument, options);
        }
export function useTelegramQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TelegramQuery, TelegramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TelegramQuery, TelegramQueryVariables>(TelegramQueryDocument, options);
        }
export type TelegramQueryHookResult = ReturnType<typeof useTelegramQuery>;
export type TelegramQueryLazyQueryHookResult = ReturnType<typeof useTelegramQueryLazyQuery>;
export type TelegramQuerySuspenseQueryHookResult = ReturnType<typeof useTelegramQuerySuspenseQuery>;
export type TelegramQueryQueryResult = Apollo.QueryResult<TelegramQuery, TelegramQueryVariables>;